import { useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Checkbox } from '../../../../../../common/html/checkbox'
import { Element } from '../../../../../../common/html/element'
import { TextEllipsisStaticLine } from '../../../../../../common/textEllipsis/TextEllipsisStaticLine'
import {
  changeSelectedPortfolioList,
  selectSelectedPortfolioList,
} from '../../popupRecommendationList/store/slice'

export const PortfolioItem = ({ data, index }) => {
  const dispatch = useDispatch()

  const [isHover, setIsHover] = useState(false)

  const selectedPortfolioList = useSelector(selectSelectedPortfolioList)

  const getItemBgColor = useMemo(() => {
    return isHover ? '#C8E3FF' : index % 2 === 0 ? '#F9F9F9' : '#FFFFFF'
  }, [isHover])

  const onMouseEnter = () => {
    setIsHover(true)
  }

  const onMouseLeave = () => {
    setIsHover(false)
  }

  const onChange = (isChecked) => {
    if (isChecked) {
      dispatch(
        changeSelectedPortfolioList([...selectedPortfolioList, data.value]),
      )
    } else {
      dispatch(
        changeSelectedPortfolioList(
          selectedPortfolioList.filter((item) => item !== data.value),
        ),
      )
    }
  }

  return (
    <Element
      style={{ backgroundColor: getItemBgColor }}
      className="dFlex"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <Element
        className="w100 dFlex"
        style={{
          fontSize: 10,
          padding: '8px 12px',
        }}
      >
        <Checkbox
          value={data.value}
          checked={selectedPortfolioList.includes(data.value)}
          onChange={onChange}
        />
        <TextEllipsisStaticLine
          text={data.label}
          isI18n={false}
          lineClamp={1}
          zIndexTooltip={13}
          appendStyle={{
            marginLeft: 4,
            color: '#2C73E8',
          }}
        />
      </Element>
    </Element>
  )
}
